import { mergeDeepRight } from 'ramda';
import { useEffect, useState } from 'react';

import { appConfig } from '~/common/config';

import { defaultConfig } from './ConfigProvider.config';

export interface UseRemoteConfigResult {
  loading: boolean;
  config: any;
}

export const useRemoteConfig: () => UseRemoteConfigResult = () => {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/config.json?v=${appConfig.version}`, { credentials: 'include' });
        const json = await response.json();
        setConfig(mergeDeepRight(defaultConfig, json));
        setLoading(false);
      } catch (error) {
        console.log('error', error);
      }
    };
    fetchData();
  }, []);

  return { loading, config };
};
